import type {
  MoveInCosts,
  MoveInCostsNumericInput,
  RenterMoveInCostsDetailsInterface,
  RenterMoveInCostsDetailsNumericInputInterface,
} from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

export const MoveInCostsDetailsModel = (
  moveInCosts: RenterMoveInCostsDetailsNumericInputInterface,
): RenterMoveInCostsDetailsInterface => {
  const {
    baseAmount = 0,
    dueDate = 0,
    groupKey = '',
    isScheduled = false,
    items = [],
    status = '',
    totalAmount = 0,
    zgFee = 0,
    sendDate = 0,
    paymentMethodId = '',
  } = moveInCosts || {};

  return {
    baseAmount,
    dueDate: formatTimestampToYMDString(dueDate),
    sendDate: formatTimestampToYMDString(sendDate),
    groupKey,
    isScheduled,
    items,
    status,
    totalAmount,
    zgFee,
    paymentMethodId,
  };
};

export const MoveInCostsModel = (moveInCosts: MoveInCostsNumericInput): MoveInCosts => {
  const {
    amount = 0,
    dateReceived = 0,
    dateRequested = 0,
    dueDate = 0,
    groupKey = '',
    moveInCostsItems,
    paymentCategory = '',
    renterStatus = '',
    totalAmount = 0,
    zgFee = 0,
    markAsPaidEligible = false,
  } = moveInCosts || {};

  return {
    amount,
    dateReceived: formatTimestampToYMDString(dateReceived),
    dateRequested: formatTimestampToYMDString(dateRequested),
    dueDate: formatTimestampToYMDString(dueDate),
    groupKey,
    moveInCostsItems,
    paymentCategory,
    renterStatus,
    totalAmount,
    zgFee,
    markAsPaidEligible,
  };
};
